export default function genererCalculAutoTlpeJour() {
  return {
    produitId: null,
    dateDebut: null,
    dateFin: null,
    quantiteDispo: 0,
    surAnnee: true,
  };
}
